import store from '../../store/store';
import { MAX_MESSAGE_SIZE } from '../../store/schema/ClauseValueType';
import { action } from 'satcheljs/lib/legacy';
import strings from 'owa-strings/owa-options-strings';
import { isAtLeastAtMostCompatible } from '../../utils/isValidClause';
import { format } from 'owa-strings';
export default action('setClauseErrorText')(function setClauseErrorText(clauseId, isValidClause, clauseValue) {
    var clause = store.inboxRulesEditState.clauseMap.get(clauseId);
    var errorText;
    if (isValidClause) {
        store.inboxRulesEditState.clauseErrorTextMap.set(clauseId, '');
        return;
    }
    if (clauseId == 'name') {
        store.inboxRulesEditState.clauseErrorTextMap.set(clauseId, strings.options_inboxRules_emptyNameError);
        return;
    }
    switch (clause.clauseType) {
        case 'category':
            errorText = format(strings.options_inboxRules_createNewCategoryError, clauseValue);
            break;
        case 'from':
            errorText = strings.options_inboxRules_emptyFromError;
            break;
        case 'to':
            errorText = strings.options_inboxRules_emptyToError;
            break;
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
            errorText = strings.options_inboxRules_emptyPhraseError;
            break;
        case 'atLeast':
        case 'atMost':
            errorText = getMessageSizeErrorText(Number(clauseValue), clauseId);
            break;
        default:
            errorText = strings.options_inboxRules_emptyDropdownError;
            break;
    }
    store.inboxRulesEditState.clauseErrorTextMap.set(clauseId, errorText);
});
function getMessageSizeErrorText(num, clauseId) {
    if (isNaN(num) || num < 1) {
        return strings.options_inboxRules_messageSizeNotANumber;
    }
    else if (num > MAX_MESSAGE_SIZE) {
        return strings.options_inboxRules_messageSizeTooLarge;
    }
    else if (!isAtLeastAtMostCompatible(clauseId)) {
        // check if the 'at least' value is <= the 'at most' value
        return format(strings.options_inboxRules_messageSizeInvalid, strings.options_inboxRules_atLeast, strings.options_inboxRules_atMost);
    }
    else {
        return '';
    }
}
//# sourceMappingURL=setClauseErrorText.js.map